module.exports = __webpack_public_path__ + "static/media/2021_Cadillac_XT6_ext_04_6NX26_1SF_GSK.18e4fa95.png";